import {
  defineStore,
  storeFactory,
  useSupabase,
  type GetterType,
} from "#imports";
import type { QueryData } from "@supabase/supabase-js";

export type SpotMedia = GetterType<ReturnType<typeof useSpotMedia>["getById"]>;

export const useSpotMedia = defineStore("spotMedia", () => {
  const supabase = useSupabase();

  const selectSpotMedia = () =>
    supabase
      .from("spot_media")
      .select("*")
      .order("created_at", { ascending: false })
      .throwOnError();

  type RawSpotMedia = QueryData<ReturnType<typeof selectSpotMedia>>[number];

  const spotMediaRawRow = (row: RawSpotMedia) => {
    const videoExtensions = ["mp4", "webm", "ogg", "mov"];
    const extension = row.file_name?.split(".").pop()?.toLowerCase() || "";
    const mediaType = videoExtensions.includes(extension) ? "video" : "image";

    return {
      ...row,
      type: mediaType,
    };
  };

  const { dataById, fetchFactory, fetchById, fetchByIds, getById, getByIds } =
    storeFactory<RawSpotMedia, ReturnType<typeof spotMediaRawRow>>(
      "spotMedia",
      async (payload) => await selectSpotMedia().in("id", payload),
      spotMediaRawRow,
    );

  const {
    metadata: metadataSpotMediaById,
    fetch: fetchSpotMediaBydId,
    result: mediaById,
  } = fetchFactory<{ spot_id: string }>(
    async (payload) => await selectSpotMedia().eq("spot_id", payload.spot_id),
  );

  return {
    dataById, // do not use, only for nuxt SSR cache transfer

    fetchById,
    fetchByIds,
    getById,
    getByIds,

    metadataSpotMediaById,
    fetchSpotMediaBydId,
    mediaById,
  };
});
